import React from 'react'

import { GenericField } from 'components/Fields'

export const MARKETING_CHECKBOXES = [{ name: 'agreement_3' }]

export const Input = ({ movePlaceholder = true, big = true, ...rest }) => (
  <GenericField movePlaceholder={movePlaceholder} big={big} {...rest} />
)
